(()=>{'use strict';
 const initialized=new WeakSet(),players=new Set(),reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const canAuto=()=>!reduce.matches&&!navigator.connection?.saveData;
 const setUp=(scope=document)=>scope.querySelectorAll('[data-wt-film]').forEach(box=>{
  if(initialized.has(box))return;initialized.add(box);
  const video=box.querySelector('video'),button=box.querySelector('[data-film-toggle]'),error=box.querySelector('[data-film-error]');
  if(!video||!button)return;
  const title=video.getAttribute('aria-label')||'product film';
  const state={video,box,auto:box.hasAttribute('data-film-auto'),userPaused:false,visible:false,systemPause:false};players.add(state);
  button.hidden=false;
  const update=()=>{button.replaceChildren(document.createTextNode(video.paused?'Play film ▷':'Pause film Ⅱ'));button.setAttribute('aria-label',(video.paused?'Play ':'Pause ')+title);};
  const pause=()=>{state.systemPause=true;video.pause();};
  const play=()=>{state.systemPause=false;video.play().catch(()=>{update();});};
  button.addEventListener('click',()=>{if(video.paused){state.userPaused=false;play();}else{state.userPaused=true;pause();}update();});
  video.addEventListener('play',()=>{state.userPaused=false;for(const other of players){if(other!==state&&!other.video.paused){other.systemPause=true;other.video.pause();}}update();});
  video.addEventListener('pause',()=>{if(!state.systemPause)state.userPaused=true;state.systemPause=false;update();});
  video.addEventListener('error',()=>{error.hidden=false;button.hidden=true;});
  if(state.auto){video.controls=false;}
  if('IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    state.visible=entry.isIntersecting&&entry.intersectionRatio>=.45;
    if(!state.visible){pause();return;}
    if(state.auto&&canAuto()&&!state.userPaused&&!document.hidden)play();
   }),{threshold:[0,.45]});observer.observe(box);
  }
  update();
 });
 document.addEventListener('visibilitychange',()=>{if(document.hidden)for(const state of players){state.systemPause=true;state.video.pause();}});
 const respectPreference=()=>{if(!canAuto())for(const state of players){if(state.auto){state.systemPause=true;state.video.pause();}}};
 reduce.addEventListener('change',respectPreference);navigator.connection?.addEventListener?.('change',respectPreference);
 setUp();document.addEventListener('shopify:section:load',event=>setUp(event.target));
 document.addEventListener('shopify:section:unload',()=>{for(const state of players)if(!state.box.isConnected){state.video.pause();players.delete(state);}});
})();
